module.exports = __webpack_public_path__ + "static/media/fotoperfil.280b514c.jpg";